'use client'

import { isNull } from 'lodash-es'
import { useEffect } from 'react'

import { ENTRY_HISTORY_LENGTH_KEY } from '@/shared/lib'

export const HistoryEntryTracker = () => {
  useEffect(() => {
    const entryHistoryLength = sessionStorage.getItem('entry_history_length')

    if (!isNull(entryHistoryLength)) return

    sessionStorage.setItem(
      ENTRY_HISTORY_LENGTH_KEY,
      String(window.history.length),
    )
  }, [])

  return null
}
